/* =========================================================
   MANEWAY COLLECTION GRID
   Filter drawer, sorting, filtering, Load more and wishlist
   for sections/mw-collection-grid.liquid.

   Filtering/sorting fetch the same section through Shopify's
   Section Rendering API (?section_id=) and swap every
   [data-mwc-swap] region, so counts, chips and results stay in
   sync with the URL.
========================================================= */

(function () {
  'use strict';

  if (window.mwCollectionLoaded) return;
  window.mwCollectionLoaded = true;

  var PRICE_DEBOUNCE = 700;
  var priceTimer = null;
  var activeRequest = null;

  function rootOf(el) {
    return el && el.closest('[data-mwc-coll]');
  }

  function sectionUrl(url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function pageUrl(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    return u.pathname + (u.search ? u.search : '');
  }


  /* =========================================================
     DRAWER
  ========================================================= */

  function openDrawer(root, opener) {
    var drawer = root.querySelector('[data-mwc-drawer]');
    if (!drawer) return;

    root.mwcOpener = opener || null;

    drawer.hidden = false;
    drawer.offsetWidth; // start the slide-in from the closed position
    drawer.classList.add('is-open');
    document.documentElement.classList.add('mwc-drawer-lock');

    root.querySelectorAll('[data-mwc-drawer-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'true');
    });

    var panel = drawer.querySelector('.mwc-drawer__panel');
    if (panel) panel.focus({ preventScroll: true });
  }

  function closeDrawer(root) {
    var drawer = root.querySelector('[data-mwc-drawer]');
    if (!drawer || drawer.hidden) return;

    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('mwc-drawer-lock');

    root.querySelectorAll('[data-mwc-drawer-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });

    if (root.mwcOpener) root.mwcOpener.focus({ preventScroll: true });

    setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
    }, 450);
  }


  /* =========================================================
     FILTER + SORT
  ========================================================= */

  function currentParams(root) {
    var form = root.querySelector('[data-mwc-filter-form]');
    var params = form
      ? new URLSearchParams()
      : new URLSearchParams(window.location.search);

    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
    }

    var sort = root.querySelector('[data-mwc-sort]');
    if (sort) params.set('sort_by', sort.value);

    params.delete('page');
    params.delete('section_id');
    params.delete('mwc_sort_ui');
    return params;
  }

  function urlFromParams(params) {
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function render(root, url, options) {
    options = options || {};
    var sectionId = root.getAttribute('data-section-id');

    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();

    root.classList.add('is-loading');

    // Remember UI state that lives inside swapped regions.
    var openAcc = [];
    root.querySelectorAll('.mw-acc[open]').forEach(function (d) {
      openAcc.push(d.getAttribute('data-mwc-acc'));
    });
    var expandedAcc = [];
    root.querySelectorAll('.mw-opts.is-expanded').forEach(function (list) {
      var acc = list.closest('.mw-acc');
      if (acc) expandedAcc.push(acc.getAttribute('data-mwc-acc'));
    });
    var focused = document.activeElement;
    var focusName = focused && root.contains(focused) && focused.matches('[data-mwc-price]')
      ? focused.name
      : null;

    return fetch(sectionUrl(url, sectionId), { signal: activeRequest.signal })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        root.querySelectorAll('[data-mwc-swap]').forEach(function (region) {
          var key = region.getAttribute('data-mwc-swap');
          var fresh = doc.querySelector('[data-mwc-swap="' + key + '"]');
          if (fresh) region.innerHTML = fresh.innerHTML;
        });

        // Clear-all links carry the sort, so refresh their hrefs too.
        ['[data-mwc-clear]'].forEach(function (sel) {
          var mine = root.querySelector(sel);
          var fresh = doc.querySelector(sel);
          if (mine && fresh) mine.setAttribute('href', fresh.getAttribute('href'));
        });

        root.querySelectorAll('.mw-acc').forEach(function (d) {
          var key = d.getAttribute('data-mwc-acc');
          if (openAcc.indexOf(key) !== -1) d.open = true;
          if (expandedAcc.indexOf(key) !== -1) {
            var list = d.querySelector('.mw-opts');
            if (list) list.classList.add('is-expanded');
          }
        });

        if (focusName) {
          var input = root.querySelector('[data-mwc-price][name="' + focusName + '"]');
          if (input) {
            input.focus({ preventScroll: true });
            var len = input.value.length;
            try { input.setSelectionRange(len, len); } catch (e) {}
          }
        }

        if (options.push !== false) {
          history.pushState({ mwColl: true }, '', pageUrl(url));
        }

        syncWishlist(root);
        observeInfinite(root);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        // Network trouble: fall back to a normal page load.
        window.location.href = pageUrl(url);
      })
      .finally(function () {
        root.classList.remove('is-loading');
      });
  }

  function applyFilters(root) {
    render(root, urlFromParams(currentParams(root)));
  }


  /* =========================================================
     LOAD MORE
  ========================================================= */

  function loadMore(root, button) {
    if (root.mwcLoadingMore) return;
    root.mwcLoadingMore = true;

    var sectionId = root.getAttribute('data-section-id');
    var wrap = button.closest('.mw-coll__more');
    button.classList.add('is-loading');
    if (wrap) wrap.classList.add('is-loading');

    fetch(sectionUrl(button.href, sectionId))
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = root.querySelector('[data-mwc-grid]');
        var freshGrid = doc.querySelector('[data-mwc-grid]');

        if (grid && freshGrid) {
          Array.prototype.slice.call(freshGrid.children).forEach(function (item) {
            grid.appendChild(item);
          });
        }

        var more = root.querySelector('.mw-coll__more');
        var freshMore = doc.querySelector('.mw-coll__more');
        if (more) {
          if (freshMore) more.replaceWith(freshMore);
          else more.remove();
        }

        syncWishlist(root);
      })
      .catch(function () {
        window.location.href = button.href;
      })
      .finally(function () {
        root.mwcLoadingMore = false;
        // Next batch: keep watching (and load again right away if the
        // sentinel is still on screen, e.g. on very tall screens).
        observeInfinite(root);
      });
  }


  /* =========================================================
     INFINITE SCROLL
     Watches the Load more link and fetches the next page before
     the shopper reaches the end of the grid.
  ========================================================= */

  function observeInfinite(root) {
    if (root.mwcInfiniteIO) {
      root.mwcInfiniteIO.disconnect();
      root.mwcInfiniteIO = null;
    }

    var trigger = root.querySelector('[data-mwc-infinite]');
    if (!trigger || !('IntersectionObserver' in window)) return;

    root.mwcInfiniteIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadMore(root, entry.target);
      });
    }, { rootMargin: '0px 0px 900px 0px' });

    root.mwcInfiniteIO.observe(trigger);
  }


  /* =========================================================
     WISHLIST
     Uses Wishlist Plus (Swym) when it's on the page; otherwise
     keeps the list in this browser.
  ========================================================= */

  var LOCAL_KEY = 'mw-wishlist';
  var swymListId = null;
  var swymItems = null;

  function withSwym(cb) {
    if (window._swat) return cb(window._swat);
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(cb);
  }

  function hasSwym() {
    return !!(window._swat && (window._swat.addToList || window._swat.addToWishList));
  }

  function readLocal() {
    try { return JSON.parse(localStorage.getItem(LOCAL_KEY)) || []; } catch (e) { return []; }
  }

  function writeLocal(ids) {
    try { localStorage.setItem(LOCAL_KEY, JSON.stringify(ids)); } catch (e) {}
  }

  function setActive(btn, on) {
    btn.classList.toggle('is-active', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var title = btn.getAttribute('data-product-title') || 'product';
    btn.setAttribute('aria-label', (on ? 'Remove ' : 'Add ') + title + (on ? ' from wishlist' : ' to wishlist'));
  }

  function productFor(btn) {
    return {
      epi: Number(btn.getAttribute('data-variant-id')),
      empi: Number(btn.getAttribute('data-product-id')),
      du: btn.getAttribute('data-product-url'),
      iu: btn.getAttribute('data-product-image'),
      dt: btn.getAttribute('data-product-title'),
      pr: Number(btn.getAttribute('data-mwc-wish-price'))
    };
  }

  function syncWishlist(scope) {
    var buttons = (scope || document).querySelectorAll('[data-mwc-wish]');
    if (!buttons.length) return;

    if (hasSwym() && swymItems) {
      buttons.forEach(function (btn) {
        setActive(btn, swymItems.indexOf(Number(btn.getAttribute('data-product-id'))) !== -1);
      });
      return;
    }

    var local = readLocal();
    buttons.forEach(function (btn) {
      setActive(btn, local.indexOf(btn.getAttribute('data-product-id')) !== -1);
    });
  }

  function loadSwymState(swat) {
    function done(products) {
      swymItems = (products || []).map(function (p) { return Number(p.empi); });
      syncWishlist(document);
    }

    if (swat.fetchLists) {
      swat.fetchLists({
        callbackFn: function (lists) {
          var list = lists && lists[0];
          swymListId = list ? list.lid : null;
          done(list ? list.listcontents : []);
        },
        errorFn: function () { done([]); }
      });
    } else if (swat.fetch) {
      swat.fetch(done);
    }
  }

  function ensureSwymList(swat, cb) {
    if (swymListId || !swat.createList) return cb(swymListId);
    swat.createList({ lname: 'My Wishlist' }, function (list) {
      swymListId = list && list.lid;
      cb(swymListId);
    }, function () { cb(null); });
  }

  function toggleWish(btn) {
    var on = !btn.classList.contains('is-active');
    var id = btn.getAttribute('data-product-id');

    // Update every heart for this product right away.
    document.querySelectorAll('[data-mwc-wish][data-product-id="' + id + '"]').forEach(function (b) {
      setActive(b, on);
    });

    if (hasSwym()) {
      var swat = window._swat;
      var product = productFor(btn);
      swymItems = swymItems || [];

      if (on) swymItems.push(product.empi);
      else swymItems = swymItems.filter(function (x) { return x !== product.empi; });

      if (swat.addToList) {
        ensureSwymList(swat, function (lid) {
          if (!lid) return;
          if (on) swat.addToList(lid, product, function () {}, function () {});
          else swat.deleteFromList(lid, product, function () {}, function () {});
        });
      } else if (on) {
        swat.addToWishList(product, function () {});
      } else if (swat.removeFromWishList) {
        swat.removeFromWishList(product, function () {});
      }
      return;
    }

    var local = readLocal().filter(function (x) { return x !== id; });
    if (on) local.push(id);
    writeLocal(local);
  }


  /* =========================================================
     CATEGORY PILLS: scroll arrows + edge fades
  ========================================================= */

  function updatePills(wrap) {
    var track = wrap.querySelector('[data-mwc-pills-track]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth;
    var hasPrev = track.scrollLeft > 4;
    var hasNext = track.scrollLeft < max - 4;
    wrap.classList.toggle('has-prev', hasPrev);
    wrap.classList.toggle('has-next', hasNext);
    var prev = wrap.querySelector('[data-mwc-pills-prev]');
    var next = wrap.querySelector('[data-mwc-pills-next]');
    if (prev) prev.hidden = !hasPrev;
    if (next) next.hidden = !hasNext;
  }

  function initPills(root) {
    root.querySelectorAll('[data-mwc-pills]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-mwc-pills-track]');
      if (!track || wrap.mwcReady) return;
      wrap.mwcReady = true;

      // Bring the active pill into view only if it's hidden past the right edge.
      var active = track.querySelector('.is-active');
      if (active) {
        var overflow = active.getBoundingClientRect().right - track.getBoundingClientRect().right;
        if (overflow > 0) track.scrollLeft = overflow + 64;
      }

      track.addEventListener('scroll', function () { updatePills(wrap); }, { passive: true });
      window.addEventListener('resize', function () { updatePills(wrap); });
      updatePills(wrap);
    });
  }

  function scrollPills(button, direction) {
    var wrap = button.closest('[data-mwc-pills]');
    var track = wrap && wrap.querySelector('[data-mwc-pills-track]');
    if (!track) return;
    track.scrollBy({ left: direction * track.clientWidth * 0.7, behavior: 'smooth' });
  }


  /* =========================================================
     MOBILE FLOATING "FILTER & SORT"
     Shows once the toolbar has scrolled away, while the grid
     is still on screen.
  ========================================================= */

  function initFloat(root) {
    var float = root.querySelector('[data-mwc-float]');
    var toolbar = root.querySelector('.mw-coll__toolbar');
    if (!float || !toolbar || !('IntersectionObserver' in window) || float.mwcReady) return;
    float.mwcReady = true;
    float.hidden = false;

    var toolbarGone = false;
    var gridVisible = false;

    function update() {
      float.classList.toggle('is-visible', toolbarGone && gridVisible);
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        toolbarGone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      });
      update();
    }).observe(toolbar);

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        gridVisible = entry.isIntersecting;
      });
      update();
    }, { rootMargin: '0px 0px -120px 0px' }).observe(root.querySelector('.mw-coll__results') || root);
  }


  /* =========================================================
     EVENTS (delegated, so swapped markup keeps working)
  ========================================================= */

  document.addEventListener('click', function (event) {
    var target = event.target;
    var root = rootOf(target);

    // Any click outside an open filter panel closes it.
    document.querySelectorAll('[data-mwc-drawer].is-open').forEach(function (drawer) {
      if (target.closest('.mwc-drawer__panel') || target.closest('[data-mwc-drawer-open]')) return;
      if (!document.contains(target)) return; // element was just swapped out by a filter update
      closeDrawer(rootOf(drawer));
    });

    var wish = target.closest('[data-mwc-wish]');
    if (wish) {
      event.preventDefault();
      toggleWish(wish);
      return;
    }

    if (!root) return;

    var opener = target.closest('[data-mwc-drawer-open]');
    if (opener) {
      openDrawer(root, opener);
      return;
    }

    var pillsPrev = target.closest('[data-mwc-pills-prev]');
    var pillsNext = target.closest('[data-mwc-pills-next]');
    if (pillsPrev || pillsNext) {
      scrollPills(pillsPrev || pillsNext, pillsPrev ? -1 : 1);
      return;
    }

    var moreOpts = target.closest('[data-mwc-more-opts]');
    if (moreOpts) {
      var list = moreOpts.previousElementSibling;
      if (list) list.classList.toggle('is-expanded');
      return;
    }

    if (target.closest('[data-mwc-drawer-close]')) {
      closeDrawer(root);
      return;
    }

    var more = target.closest('[data-mwc-load-more]');
    if (more) {
      event.preventDefault();
      loadMore(root, more);
      return;
    }

    var link = target.closest('[data-mwc-link], [data-mwc-clear]');
    if (link) {
      event.preventDefault();
      render(root, link.getAttribute('href'));
    }
  });

  document.addEventListener('change', function (event) {
    var root = rootOf(event.target);
    if (!root) return;

    if (event.target.matches('[data-mwc-sort]')) {
      applyFilters(root);
      return;
    }

    if (event.target.matches('[data-mwc-sort-radio]')) {
      var select = root.querySelector('[data-mwc-sort]');
      if (select) select.value = event.target.value;
      applyFilters(root);
      return;
    }

    if (event.target.closest('[data-mwc-filter-form]') && !event.target.matches('[data-mwc-price]')) {
      applyFilters(root);
    }
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('[data-mwc-price]')) return;
    var root = rootOf(event.target);
    clearTimeout(priceTimer);
    priceTimer = setTimeout(function () { applyFilters(root); }, PRICE_DEBOUNCE);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-mwc-filter-form]');
    if (!form) return;
    event.preventDefault();
    clearTimeout(priceTimer);
    applyFilters(rootOf(form));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mwc-coll]').forEach(closeDrawer);
  });

  window.addEventListener('popstate', function () {
    var root = document.querySelector('[data-mwc-coll]');
    if (root) render(root, window.location.href, { push: false });
  });

  // Other sections that render product cards later (e.g. related products) call this.
  window.mwcSyncWishlist = syncWishlist;

  function init() {
    document.querySelectorAll('[data-mwc-coll]').forEach(function (root) {
      initPills(root);
      initFloat(root);
      observeInfinite(root);
    });
    syncWishlist(document);
    withSwym(function (swat) { loadSwymState(swat); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-init when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-mwc-coll]');
    if (!root) return;
    initPills(root);
    initFloat(root);
    observeInfinite(root);
    syncWishlist(root);
  });
})();
